import Utils from '../../modules/utils'

const updateStatus = (status, contactIds, callbackFunc) => {
  const url = 'contact_status'
  const data = {contactIds, status}
  Utils.post(url, data, callbackFunc)
}

export {updateStatus}
